import { n as containerShortcuts } from "./container-SVSSaqGJ.mjs";
//#region src/shortcuts.ts
const shortcuts = [...containerShortcuts];
//#endregion
export { shortcuts };
